module.exports = __webpack_public_path__ + "static/media/21-1.b2336971.mp3";